import React, { Component } from 'react'
import uuidv4 from 'uuid/v4'
import { Modal, Carousel } from 'antd-mobile'

import styles from './index.css'
import VideoBanner from '../Banner/ideaVideoBanner'

const ImageCarouselStyle = {
  width: document.body.clientWidth,
  height: document.body.clientWidth,
}
export default class IdeaContent extends Component {
  state = {
    showModal: false,
    currentImage: 0,
  }

  toggleModal = (type, index) => () => {
    this.setState({ showModal: type === 'open' }, () =>
      this.setState({ currentImage: type === 'open' ? index : 0 })
    )
  }

  render() {
    const {
      hasImage,
      hasVideo,
      hasLink,
      text,
      imgList,
      linkUrls,
      video,
    } = this.props
    const { showModal, currentImage } = this.state
    const videoSize = {
      width: document.body.clientWidth - 68,
      height: 150,
    }
    return (
      <div className={styles.IdeaContent}>
        <div dangerouslySetInnerHTML={{ __html: text }} />
        {hasImage && (
          <div className={styles.IdeaImgContainer}>
            {imgList.map((url, index) => (
              <div key={uuidv4()} onClick={this.toggleModal('open', index)}>
                <img src={url} alt="" />
              </div>
            ))}
          </div>
        )}
        {hasImage && (
          <Modal
            visible={showModal}
            closable
            maskClosable
            onClose={this.toggleModal('close')}
            className={styles.IdeaImageFullScreen}
          >
            <div style={ImageCarouselStyle}>
              <Carousel autoplay={false} infinite selectedIndex={currentImage}>
                {imgList.map(imgUrl => (
                  <div
                    key={uuidv4()}
                    className={styles.CarouselContainer}
                    style={ImageCarouselStyle}
                  >
                    <img src={imgUrl} alt="" />
                  </div>
                ))}
              </Carousel>
            </div>
          </Modal>
        )}
        {hasVideo && (
          <div className={styles.IdeaVideo}>
            <VideoBanner {...video} videoSize={videoSize} />
          </div>
        )}
        {hasLink &&
          linkUrls.map(url => (
            <a key={uuidv4()} href={url}>
              {url}
            </a>
          ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/IdeaItem/IdeaContent.js